import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

function AccessibleNavigationAnnouncer() {
  const [message, setMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    // ignore the /
    let timeoutId;
    if (location.pathname.slice(1)) {
      // make sure navigation has occurred and screen reader is ready
      timeoutId = setTimeout(
        () => setMessage(`Navigated to ${location.pathname.slice(1)} page.`),
        500
      );
    } else {
      setMessage("");
    }

    // Cleanup function to clear the timeout if component unmounts
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [location]);

  return (
    <span
      className="sr-only"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </span>
  );
}

export default AccessibleNavigationAnnouncer;
